import React from 'react';

const NeedFurtherAssistance = () => {
  return (
    <div>
      <h3 style={{ fontSize: "20px", fontWeight: "300", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
        Need Further Assistance?
      </h3>
      <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F" }}>
        For additional help, contact our 24/7 live support team via live chat on the Gatnix website, or call us at{" "}
        <strong style={{ color: "#000000" }}>+1 (614) 421-7545</strong>.
      </p>
    </div>
  );
};

export default NeedFurtherAssistance;
